import React from 'react'
import {WarningAlert, ContentAlert, AlertTitle, AlertMessage} from "./Alerts.styled";

const Alerts = ({top, right, left, width, title, message, severity, onClose, isInline}) => {
  return (
    <WarningAlert
      severity={severity}
      width={width}
      top={top}
      right={right}
      left={left}
      isInline={isInline} 
      onClose={onClose}
    >
      <ContentAlert>
          {title && <AlertTitle>{title}</AlertTitle>}
          <AlertMessage>{message}</AlertMessage>
      </ContentAlert>
    </WarningAlert>
  )
}

export default Alerts
